var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOhLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OH_logo",
    "data-name": "OH logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 38.904,
    viewBox: "0 0 120 38.904",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2768",
    "data-name": "Rectangle 2768",
    width: 120,
    height: 38.904,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3833",
    "data-name": "Group 3833",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4378",
    "data-name": "Path 4378",
    d: "M19.452,0C6.234,0,0,6.234,0,19.452S6.234,38.9,19.452,38.9,38.9,32.67,38.9,19.452,32.669,0,19.452,0",
    fill: "#00b2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4379",
    "data-name": "Path 4379",
    d: "M34.155,32.653h0a12.942,12.942,0,0,0-13.008-1,13.016,13.016,0,0,0,7.38,10.764,12.943,12.943,0,0,0,5.638,11.77A13.017,13.017,0,0,0,39.8,42.408a12.943,12.943,0,0,0,7.38-10.77,13.018,13.018,0,0,0-13.02,1.015m8.966,3.163A10.249,10.249,0,0,1,37.7,40.346a3.178,3.178,0,0,1-3.483-.6,3.38,3.38,0,0,0,.6,3,2.2,2.2,0,0,0,1.074.569,3.212,3.212,0,0,0,1.216.028,10.255,10.255,0,0,1-2.954,7.311,10.517,10.517,0,0,1-1.588-2.068,10.248,10.248,0,0,1-1.215-6.957,3.178,3.178,0,0,1,2.258-2.718,3.382,3.382,0,0,0-2.9-.975,2.2,2.2,0,0,0-1.03.645,3.21,3.21,0,0,0-.634,1.044,10.256,10.256,0,0,1-4.848-6.21,10.527,10.527,0,0,1,2.585-.341A10.25,10.25,0,0,1,33.424,35.5a3.178,3.178,0,0,1,1.225,3.314,3.381,3.381,0,0,0,2.293-2.021A2.2,2.2,0,0,0,36.9,35.58a3.206,3.206,0,0,0-.591-1.075,10.255,10.255,0,0,1,7.81-1.1,10.527,10.527,0,0,1-1,2.409",
    transform: "translate(-14.712 -21.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4380",
    "data-name": "Path 4380",
    d: "M168.559,20.312a7.029,7.029,0,0,1-7.271-7.055v-.039a7.294,7.294,0,0,1,14.582-.039v.039a7.094,7.094,0,0,1-7.31,7.095m4.155-7.095a4.168,4.168,0,0,0-4.155-4.312,4.1,4.1,0,0,0-4.116,4.273v.039a4.168,4.168,0,0,0,4.155,4.312,4.1,4.1,0,0,0,4.116-4.272Z",
    transform: "translate(-112.208 -4.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4381",
    "data-name": "Path 4381",
    d: "M221.061,27.514v-5.86c0-1.411-.666-2.136-1.8-2.136s-1.862.725-1.862,2.136v5.86h-2.979v-10.5H217.4V18.5a3.716,3.716,0,0,1,3.077-1.686c2.254,0,3.567,1.49,3.567,3.9v6.8Z",
    transform: "translate(-149.17 -11.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4382",
    "data-name": "Path 4382",
    d: "M255.049,22c-1.822,0-3.057-.725-3.057-3.156V13.867h-1.254V11.319h1.254V8.634h2.979v2.685h2.469v2.548H254.97v4.488c0,.686.294,1.019.96,1.019A3.033,3.033,0,0,0,257.4,19v2.391a4.391,4.391,0,0,1-2.352.608",
    transform: "translate(-174.438 -6.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    "data-name": "Path 4383",
    d: "M284.051,27.694V26.557a4.039,4.039,0,0,1-3.175,1.333c-1.98,0-3.607-1.137-3.607-3.214v-.039c0-2.293,1.745-3.352,4.234-3.352a7.466,7.466,0,0,1,2.567.431V21.54c0-1.235-.764-1.921-2.254-1.921a7.73,7.73,0,0,0-2.9.568l-.745-2.273a9.269,9.269,0,0,1,4.077-.843c3.254,0,4.684,1.686,4.684,4.527v6.1Zm.059-4.233a4.619,4.619,0,0,0-1.9-.392c-1.274,0-2.058.51-2.058,1.45v.039c0,.8.667,1.274,1.627,1.274,1.391,0,2.332-.764,2.332-1.842Z",
    transform: "translate(-192.897 -11.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4384",
    "data-name": "Path 4384",
    d: "M322.341,19.919c-1.979,0-3.195,1.2-3.195,3.7V27.5h-2.979V17h2.979v2.117A3.245,3.245,0,0,1,322.5,16.8v3.116Z",
    transform: "translate(-219.958 -11.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4385",
    "data-name": "Path 4385",
    d: "M341.991,4.963h3.136V7.609h-3.136Zm.078,3.8h2.979v10.5h-2.979Z",
    transform: "translate(-237.924 -3.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4386",
    "data-name": "Path 4386",
    d: "M362.659,27.749a5.46,5.46,0,0,1-5.664-5.429v-.039a5.689,5.689,0,0,1,11.367-.039v.039a5.514,5.514,0,0,1-5.7,5.468m2.764-5.468a2.791,2.791,0,0,0-2.764-2.9,2.691,2.691,0,0,0-2.724,2.861v.039a2.791,2.791,0,0,0,2.763,2.9,2.691,2.691,0,0,0,2.724-2.861Z",
    transform: "translate(-248.362 -11.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4387",
    "data-name": "Path 4387",
    d: "M173.8,90.886V85.378h-5.566v5.507h-3.018V77.167h3.018V82.6H173.8V77.167h3.018V90.886Z",
    transform: "translate(-114.942 -53.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4388",
    "data-name": "Path 4388",
    d: "M219.15,93.573h-7.31a2.437,2.437,0,0,0,2.568,2.058,3.443,3.443,0,0,0,2.548-1.078l1.7,1.509a5.549,5.549,0,0,1-9.78-3.469v-.039a5.23,5.23,0,0,1,5.193-5.468c3.508,0,5.116,2.724,5.116,5.7v.039c0,.294-.02.47-.039.745m-5.076-4.1a2.341,2.341,0,0,0-2.273,2.234h4.488a2.253,2.253,0,0,0-2.215-2.234",
    transform: "translate(-145.318 -60.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4389",
    "data-name": "Path 4389",
    d: "M253.463,97.966V96.829a4.04,4.04,0,0,1-3.175,1.333c-1.98,0-3.606-1.137-3.606-3.215v-.039c0-2.293,1.744-3.351,4.233-3.351a7.466,7.466,0,0,1,2.567.431v-.176c0-1.235-.764-1.921-2.254-1.921a7.73,7.73,0,0,0-2.9.568l-.745-2.274a9.281,9.281,0,0,1,4.077-.842c3.254,0,4.684,1.686,4.684,4.528v6.1Zm.059-4.233a4.624,4.624,0,0,0-1.9-.392c-1.274,0-2.058.51-2.058,1.451v.039c0,.8.667,1.274,1.627,1.274,1.391,0,2.332-.764,2.332-1.842Z",
    transform: "translate(-171.617 -60.765)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2767",
    "data-name": "Rectangle 2767",
    width: 2.979,
    height: 14.307,
    transform: "translate(87.038 22.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4390",
    "data-name": "Path 4390",
    d: "M306.827,92.273c-1.822,0-3.057-.725-3.057-3.156V84.139h-1.254V81.591h1.254V78.906h2.979v2.685h2.469v2.548h-2.469v4.488c0,.686.294,1.019.96,1.019a3.033,3.033,0,0,0,1.47-.372v2.391a4.391,4.391,0,0,1-2.352.608",
    transform: "translate(-210.46 -54.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4391",
    "data-name": "Path 4391",
    d: "M337.753,89.541v-5.86c0-1.411-.666-2.136-1.8-2.136s-1.862.725-1.862,2.136v5.86h-2.979V75.234h2.979v5.292a3.716,3.716,0,0,1,3.077-1.686c2.254,0,3.567,1.49,3.567,3.9v6.8Z",
    transform: "translate(-230.353 -52.34)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOhLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/OH logo.3db499fdf92b377e43a3c7914a417422.svg";